import React from 'react';
import { Wordmark } from './Wordmark';
import { Monogram } from './Monogram';
export function VeraReserve() {
  return <section className="py-40 px-6 md:px-12 lg:px-24 max-w-7xl mx-auto border-y border-brass" data-id="element-74" data-mp="3ksppg0ssis9x">
      {/* Flagship label and wordmark lockup */}
      <div className="flex flex-col items-center text-center mb-8" data-id="element-75" data-mp="3gpt2xz04qc0p">
        <div className="font-mono text-xs uppercase tracking-[0.4em] text-brass mb-10" data-id="element-76" data-mp="3bunm3ell3njh">
          The Flagship
        </div>

        <Wordmark size="xl" submark="Reserve" align="center" data-id="element-77" data-mp="cbmmju0yxx22" />

        <div className="mt-10 mb-6" data-id="element-78" data-mp="8dov0kjq6yvi">
          <Monogram className="text-sm" rule data-id="element-79" data-mp="8aj8nd2heb3h" />
        </div>
      </div>

      {/* Framing line — the retainer as a managed whole */}
      <p className="font-serif font-light text-ink/80 text-xl md:text-2xl text-center max-w-2xl mx-auto mb-24 leading-relaxed" data-id="element-80" data-mp="3ukdddrq51r6n">
        Chief of staff for your health. We handle the training, the meals, the
        travel, the recovery, the medical coordination. Everything moves in one
        direction without you having to think about it.
      </p>

      {/* The three pillars — Strategic Refinement treatment: large brass
              numeral, brass hairline rule, serif headline, then body */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-12 mb-32" data-id="element-81" data-mp="f57hyezg8biq">
        <div data-id="element-82" data-mp="k391f10secuq">
          <div className="font-serif font-light text-brass text-6xl md:text-7xl leading-none mb-6" data-id="element-83" data-mp="k2pt8c0xv2tw">
            01
          </div>
          <div className="h-px w-full bg-brass/50 mb-8" aria-hidden="true" data-id="element-84" data-mp="5d1rxasrc466" />
          <h3 className="font-serif font-normal uppercase tracking-[0.1em] text-2xl md:text-3xl leading-tight mb-5" data-id="element-85" data-mp="a6d13il1kx19">
            Health Operations
          </h3>
          <p className="font-sans text-base font-light text-ink/70 leading-relaxed" data-id="element-86" data-mp="1d11sswaq4ja">
            Training, nutrition, recovery, and the bloodwork logistics.
            Coordinated as one.
          </p>
        </div>

        <div data-id="element-87" data-mp="3nkr6j0p6d5rg">
          <div className="font-serif font-light text-brass text-6xl md:text-7xl leading-none mb-6" data-id="element-88" data-mp="3nkhgjd44qylr">
            02
          </div>
          <div className="h-px w-full bg-brass/50 mb-8" aria-hidden="true" data-id="element-89" data-mp="34h5x7fezqlic" />
          <h3 className="font-serif font-normal uppercase tracking-[0.1em] text-2xl md:text-3xl leading-tight mb-5" data-id="element-90" data-mp="2znuv1rl4iswr">
            Travel &amp; Environment
          </h3>
          <p className="font-sans text-base font-light text-ink/70 leading-relaxed" data-id="element-91" data-mp="2pqym5krbc4ro">
            Hotels, meals, gyms, jet lag. Sorted before you land.
          </p>
        </div>

        <div data-id="element-92" data-mp="3nc4dcjj4oyj5">
          <div className="font-serif font-light text-brass text-6xl md:text-7xl leading-none mb-6" data-id="element-93" data-mp="3ifneauae4zra">
            03
          </div>
          <div className="h-px w-full bg-brass/50 mb-8" aria-hidden="true" data-id="element-94" data-mp="3df9hk8e8pc8k" />
          <h3 className="font-serif font-normal uppercase tracking-[0.1em] text-2xl md:text-3xl leading-tight mb-5" data-id="element-95" data-mp="38hpqg7wg14z7">
            Executive Integration
          </h3>
          <p className="font-sans text-base font-light text-ink/70 leading-relaxed" data-id="element-96" data-mp="21yrie0j9cvi8">
            Looped in with your EA. Out of your inbox.
          </p>
        </div>
      </div>

      <div className="flex flex-col items-center text-center max-w-2xl mx-auto" data-id="element-97" data-mp="cltl930dxtg7">
        <p className="font-serif font-light text-ink/80 text-xl md:text-2xl leading-relaxed mb-12" data-id="element-98" data-mp="hjv35km2rmq3">
          By invitation. The roster stays small on purpose.
        </p>
        <a href="#application" className="cta-link" data-id="element-99" data-mp="r9epj08zxypp">
          Begin the Application
          <span className="ml-2 font-serif text-lg leading-none" data-id="element-100" data-mp="w89eyl1gylis">→</span>
        </a>
      </div>
    </section>;
}